import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  takePlo5SeatService,
  takePlo5ActionService,
  updatePlo5PlayerSittingStatusService,
  updatePlo5PlayerSitOutNextBBService,
  updatePlo5BuyInAmountService,
  changePlo5SeatService,
  getPlo5GameTablesService,
  runItTwiceDecisionService
} from 'network/services/Plo5GameManagement.service'

export const getPlo5GameTablesThunk = createAsyncThunk(
  'plo5/getGameTables',
  async ({ data}, { rejectWithValue }) => {
    try {
      const response = await getPlo5GameTablesService(data)
      return response
    } catch (error) {
      return rejectWithValue('Failed to fetch game tables')
    }
  }
)

export const takePlo5SeatThunk = createAsyncThunk(
  'plo5/takeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo5SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo5 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take seat')
    }
  }
)

export const takePlo5ActionThunk = createAsyncThunk(
  'plo5/takeAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo5ActionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo5 action:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take action')
    }
  }
)

export const updatePlo5PlayerSittingStatusThunk = createAsyncThunk(
  'plo5/updatePlayerSittingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo5PlayerSittingStatusService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo5 player sitting status:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sitting status')
    }
  }
)

export const updatePlo5PlayerSitOutNextBBThunk = createAsyncThunk(
  'plo5/updatePlayerSitOutNextBB',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo5PlayerSitOutNextBBService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo5 player sit out next BB:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sit out next BB')
    }
  }
)

export const updatePlo5BuyInAmountThunk = createAsyncThunk(
  'plo5/updateBuyInAmount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo5BuyInAmountService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo5 buy-in amount:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update buy-in amount')
    }
  }
)

export const changePlo5SeatThunk = createAsyncThunk(
  'plo5/changeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await changePlo5SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error changing Plo5 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to change seat')
    }
  }
)

export const runItTwiceDecisionThunk = createAsyncThunk(
  'plo5/runItTwiceDecision',
  async (data, { rejectWithValue }) => {
    try {
      const response = await runItTwiceDecisionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error submitting run it twice decision:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to submit decision')
    }
  }
)
